import { Rating } from "react-simple-star-rating";
export const data = [
    {
        id: 1,
        title: 'Day tour',
        type: 'nature',
        image: './images/tajmahal.jpeg',
        isVideo: false,
        images: {
            image1: '../images/pagesimage/Taj-Mahal.jpg',
            image2: '../images/pagesimage/tajmahal1.jpg ',
            image3: './images/tajmahal.jpeg',
        },
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Tajmahal: This is a longer card with supporting text below',
        page_description: 'this is page description',
        duration: '1 Hour',
        discount: 'From 2842',
        price: '₹ 3250',
        review_count: '(232 review)',
        person: 'per person',
        time: '10-12 hours',
        group: 'Large group',
        picup: 'Picup available',
        rating: <Rating />,
        path: '/pages/page4'
    },
    {
        id: 2,
        type: 'nature',
        title: 'Guided tour',
        image: './images/Qutubminar.jpg',
        isVideo: false,
        images: {
            image1: '../images/pagesimage/Taj-Mahal.jpg',
            image2: '../images/pagesimage/tajmahal1.jpg',
            image3: './images/tajmahal.jpeg',
        },
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Guugram city: This is a longer card with supporting text below',
        duration: '1 Hour',
        discount: 'From 2842',
        price: ' ₹ 500',
        review_count: '(232 review)',
        person: 'per person',
        time: '3-4 hours',
        group: 'small group',
        picup: 'Picup available',
        rating: <Rating />,
        path: '/pages/page2'

    },
    {
        id: 3,
        type: 'nature',
        title: 'Guided tour',
        isVideo: true,
        image: './images/Qutubminar.jpg',
        images: {
            image1: '../videos/Tropical.mp4',
            image2: '../videos/nature1.mp4',
            image3: 'https://mdbcdn.b-cdn.net/img/video/Agua-natural.mp4',
        },
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Guugram city: This is a longer card with supporting text below',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
        path: '/pages/page3'
    },
    {
        id: 4,
        type: 'nature',
        title: 'Guided tour',
        isVideo: false,
        image: './images/redfort.jpg',
        images: {
            image1: '../images/redfort.jpg',
            image2: '../images/pagesimage/redfort2.webp',
            image2: '../images/pagesimage/Redfortog.webp',
        },
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Guugram city: This is a longer card with supporting text below',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
        review_count: '(232 review)',
        person: 'per person',
        time: '3-4 hours',
        group: 'small group',
        picup: 'Picup available',
        rating: <Rating />,
        path: '/pages/page4'
    },
    {
        id: 5,
        type: 'nature',
        title: 'Guided tour',
        isVideo: false,
        image: './images/indiagate3.webp',
        images: {
            image1: './images/indiagate3.webp',
            image2: '../images/pagesimage/india2.webp',
            image3: '../images/pagesimage/india3.jpg',
        },
        image1: '../images/pagesimage/india2.webp',
        image2: '../images/pagesimage/india3.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Guugram city: This is a longer card with supporting text below',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
        review_count: '(232 review)',
        person: 'per person',
        time: '3-4 hours',
        group: 'small group',
        picup: 'Picup available',
        rating: <Rating />,
        path: '/pages/page5'
    },
    {
        id: 6,
        type: 'nature',
        title: 'Guided tour',
        isVideo: false,
        image: './images/cyberhub.webp',
        images: {
            image1: './images/cyberhub.webp',
            image2: '../images/Gurgaon.webp',
            image3: '../images/ambience mall.jpg',
        },
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Guugram city: This is a longer card with supporting text below',
        duration: '1 Hour',
        price: ' ₹ 250',
        review_count: '(232 review)',
        person: 'per person',
        time: '3-4 hours',
        group: 'small group',
        picup: 'Picup available',
        rating: <Rating />,
        path: '/pages/page6'
    },
    {
        id: 7,
        type: 'nature',
        title: 'Guided tour',
        image: './images/Jantar-Mantar-Delhi.jpg',
        isVideo: false,
        images: {
            image1: './images/Jantar-Mantar-Delhi.jpg',
            image2: '../images/pagesimage/jantar.jpg',
            image3: '../images/pagesimage/jantar2.jpg',
        },

        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Guugram city: This is a longer card with supporting text below',
        duration: '1 Hour',
        price: '₹ 500',
        review_count: '(232 review)',
        person: 'per person',
        time: '3-4 hours',
        group: 'small group',
        picup: 'Picup available',
        rating: <Rating />,
        path: '/pages/page7'
    },
    {
        id: 8,
        type: 'nature',
        title: 'Guided tour',
        image: './images/akashardham.jpg',
        image1: '../images/pagesimage/akshar.jpg',
        image2: '../images/pagesimage/akshardham.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Guugram city: This is a longer card with supporting text below',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
        review_count: '(232 review)',
        person: 'per person',
        time: '3-4 hours',
        group: 'small group',
        picup: 'Picup available',
        rating: <Rating />,
        path: '/pages/page8'


    },
    {
        id: 9,
        type: 'culture',
        title: 'Day tour',
        image: './images/garden.jpg',
        image1: '../images/pagesimage/n1.jpg',
        image2: '../images/pagesimage/N1.2.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi:The Garden of Five Senses is a park  ',
        duration: '12 Hour',
        price: 'From  ₹ 100  per person',
        review_count: '(232 review)',
        person: 'per person',
        time: '3-4 hours',
        group: 'small group',
        picup: 'Picup available',
        rating: <Rating />,

        path: '/pages/page6'

    },
    {
        id: 10,
        type: 'culture',
        title: 'Day tour',
        image: './images/central-park1-1.jpg',
        image1: '../images/pagesimage/N2.jpg',
        image2: '../images/pagesimage/N2.2.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: Located in the heart of Delhi in Connaught Place, Central Park',
        duration: '12 Hour',
        price: 'From ₹ 100 per person',
        path: '/pages/page7'
    },
    {
        id: 11,
        type: 'culture',
        title: 'Day tour',
        image: './images/buddha-jayanti-park1-1.jpg',
        image1: '../images/pagesimage/N3.jpg',
        image2: '../images/pagesimage/N3.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi:Buddha Jayanti Park is located near Vandemataram Marg ',
        duration: '12 Hour',
        price: 'From ₹ 12342 per person',
        path: '/pages/page8'
    },
    {
        id: 12,
        type: 'culture',
        title: 'Day tour',
        image: './images/deer-park1-1.jpg',
        image1: '../images/pagesimage/N4.jpg',
        image2: '../images/pagesimage/N4.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: Deer Park located in the subdivision of Hauz Khas in South Delhi',
        duration: '12 Hour',
        price: 'From ₹ 12342 per person',
        path: '/pages/page9'

    },
    {
        id: 13,
        type: 'culture',
        title: 'Day tour',
        image: './images/humayuns.jpg',
        image1: '../images/pagesimage/N5.jpg',
        image2: '../images/pagesimage/N5.1jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: Humayuns tomb is located in Nizamuddin East',
        duration: '12 Hour',
        price: 'From ₹ 12342 per person',
    },
    {
        id: 14,
        type: 'culture',
        title: 'Day tour',
        image: './images/lodhi-garden1-1.jpg',
        image1: '../images/pagesimage/N6.jpg',
        image2: '../images/pagesimage/N7.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: The gardens are situated between Khan Market and Safdarjungs Tomb on Lodi Road',
        duration: '12 Hour',
        price: 'From ₹ 12342 per person',
    },
    {
        id: 15,
        type: 'culture',
        title: 'Day tour',
        image: './images/japanese-park1-1.jpg',
        image1: '../images/pagesimage/N7.jpg',
        image2: '../images/pagesimage/N7.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: Japanese Park is a newly constructed beautiful park situated in the Rohini area of Delhi.',
        duration: '12 Hour',
        price: 'From ₹ 12342 per person',
    },
    {
        id: 16,
        type: 'culture',
        title: 'Day tour',
        image: './images/mughal-garden1-1.jpg',
        image1: '../images/pagesimage/N8.webp',
        image2: '../images/pagesimage/N8.1.webp',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: The Mughal Gardens are located inside the Rashtrapati Bhawan Complex',
        duration: '12 Hour',
        price: 'From ₹ 12342 per person',
    },
    {
        id: 25,
        type: 'food',
        title: 'Day tour',
        image: './images/hotel1.webp',
        image1: '../images/pagesimage/Food1.jpg',
        image2: '../images/pagesimage/Food1.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi:  Zen restaurant is still the most popular Oriental Restaurant in Connaught Place',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
        path: '/pages/page14'

    },
    {
        id: 26,
        type: 'food',
        title: 'Day tour',
        image: './images/hotel2.webp',
        image1: '../images/pagesimage/Food2.jpg',
        image2: '../images/pagesimage/Food2.2.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: Ardor literally means great enthusiasm or passion',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
        path: '/pages/page15'
    },
    {
        id: 27,
        type: 'food',
        title: 'Day tour',
        image: './images/hotel3.webp',
        image1: '../images/pagesimage/Food3.jpg',
        image2: '../images/pagesimage/Food3.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi:  The Warehouse cafe is heaven for all the food lovers and the Chilli Chicken served here is a must try dish.',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
        path: '/pages/page17'
    },
    {
        id: 28,
        type: 'food',
        title: 'Guided tour',
        image: './images/chaibar.webp',
        image1: '../images/pagesimage/Food4.jpg',
        image2: '../images/pagesimage/Food4.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi:Its one of those good restaurants in Cp which is a paradise for bibliophiles as well.',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
    },
    {
        id: 29,
        type: 'food',
        title: 'Day tour',
        image: './images/hotel4.webp',
        image1: '../images/pagesimage/Food5.webp',
        image2: '../images/pagesimage/Food5.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: This is a longer card with supporting text below',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
    },
    {
        id: 30,
        type: 'food',
        title: 'Guided tour',
        image: './images/hotel6.webp',
        image1: '../images/pagesimage/Food6.webp',
        image2: '../images/pagesimage/Food6.1.webp',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: This is a longer card with supporting text below',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
    },
    {
        id: 31,
        type: 'food',
        title: 'Guided tour',
        image: './images/hotel7.webp',
        image1: '../images/pagesimage/Food7.jpg',
        image2: '../images/pagesimage/Food7.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: This is a longer card with supporting text below',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
    },
    {
        id: 32,
        type: 'food',
        title: 'Guided tour',
        image: './images/oden.webp',
        image1: '../images/pagesimage/Food8.jpg',
        image2: '../images/pagesimage/Food8.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: This is a longer card with supporting text below',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
    },
    {
        id: 17,
        type: 'activities',
        title: 'Day tour',
        image: './images/waterpark.png',
        image1: '../images/pagesimage/ad1.jpg',
        image2: '../images/pagesimage/ad1.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: Located near the Metro Walk Mall in Rohini Adventure Island is a popular water park ',
        duration: '12 Hour',
        price: 'From ₹ 1234 per person',
        path: '/pages/page10'
    },
    {
        id: 18,
        type: 'activities',
        title: 'Day tour',
        image: './images/trampoline.webp',
        image1: '../images/pagesimage/ad2.webp',
        image2: '../images/pagesimage/ad2.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: Visit the famous indoor amusement park in Gurgaon and spend your fun-packed day',
        duration: '12 Hour',
        price: 'From ₹ 1234 per person',
        path: '/pages/page11'
    },
    {
        id: 19,
        type: 'activities',
        title: 'Day tour',
        image: './images/snowmasti.avif',
        image1: '../images/pagesimage/ad3.jpg',
        image2: '../images/pagesimage/ad3.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi:Snow World in DLF Mall of India, Noida is the perfect place for a snowy respite.',
        duration: '12 Hour',
        price: 'From ₹ 1234 per person',
        path: '/pages/page12'
    },
    {
        id: 20,
        type: 'activities',
        title: 'Day tour',
        heading: 'sushant',
        image: './images/fly.avif',
        image1: '../images/pagesimage/ad4.jpg',
        image2: '../images/pagesimage/ad4.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: Reach the activity location in Gurgaon and get ready for an adventurous activity of a paramotor flight.',
        duration: '12 Hour',
        price: 'From ₹ 12342 per person',
        path: '/pages/page13'
    },
    {
        id: 21,
        type: 'activities',
        title: 'Guided tour',
        image: './images/eodadventure.avif',
        image1: '../images/pagesimage/ad5.webp',
        image2: '../images/pagesimage/ad5.1.webp',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: EOD or "Every Other Day," is a multi-adventure park in the heart of Delhi, surrounded by lush greenery.',
        duration: '12 Hour',
        price: 'From ₹ 12342 per person',
    },
    {
        id: 22,
        type: 'activities',
        title: 'Day tour',
        image: './images/adventure.avif',
        image1: '../images/pagesimage/ad6.jpg',
        image2: '../images/pagesimage/ad6.1.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: This is a longer card with supporting text below',
        duration: '12 Hour',
        price: 'From ₹ 12342 per person',
    },
    {
        id: 23,
        type: 'activities',
        title: 'Day tour',
        image: './images/mojoland.avif',
        image1: '../images/pagesimage/Taj-Mahal.jpg',
        image2: '../images/pagesimage/Taj-Mahal.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: This is a longer card with supporting text below',
        duration: '12 Hour',
        price: 'From ₹ 12342 per person',
    },
    {
        id: 24,
        type: 'activities',
        title: 'Day tour',
        image: './images/park.avif',
        image1: '../images/pagesimage/Taj-Mahal.jpg',
        image2: '../images/pagesimage/Taj-Mahal.jpg',
        video1: '../videos/taj.mp4',
        video2: '../videos/taj.mp4',
        video3: '../videos/taj.mp4',
        description: 'Delhi: This is a longer card with supporting text below',
        duration: '12 Hour',
        price: 'From ₹ 12342 per person',
    }
];

export const cityData = [
    {
        id: 1,
        cityname: 'Gurgaon',
        activity: '6 activity',
        image: './images/Gurgaon.webp'
    },
    {
        id: 2,
        cityname: 'Manali',
        activity: '4 activity',
        image: './images/manali.jpg'

    },
    {
        id: 3,
        cityname: 'Mumbai',
        activity: '7 activity',
        image: './images/Mumbai.webp'
    },
    {
        id: 4,
        cityname: 'Nanital',
        activity: '8 activity',
        image: './images/nanital.jpg'

    }
];
export const inspiringData = [
    {
        id: 1,
        cityname: 'Vrindavan',
        image: './images/vrindavan.jpg'

    },
    {
        id: 2,
        cityname: 'Varanasi',
        image: './images/varanasi.jpg'

    },
    {
        id: 3,
        cityname: 'Maniali',
        image: './images/manali.jpg'

    },
    {
        id: 4,
        cityname: 'Haridwar',
        image: './images/haridwar.jpg'

    },
    {
        id: 5,
        cityname: 'Shimla',
        image: './images/Shimla.jpg'

    },
    {
        id: 6,
        cityname: 'Jaipur',
        image: './images/Jaipur.jpg'

    },
]
export const headingCards = [
    {
        id: 1,
        title: 'Day tour',
        image: './images/tajmahal.jpeg',
        description: 'Tajmahal: This is a longer card with supporting text below',
        duration: '1 Hour',
        discount: 'From 2842',
        price: '₹ 3250',
        review_count: '(232 review)',
        person: 'per person',
        time: '3-4 hours',
        group: 'small group',
        picup: 'Picup available',
        rating: <Rating />,
        path: '/pages/page4'
    },
    {
        id: 2,
        title: 'Guided tour',
        image: './images/Qutubminar.jpg',
        description: 'Guugram city: This is a longer card with supporting text below',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
        path: '/pages/page2'

    },
    {
        id: 3,
        title: 'Guided tour',
        image: './images/lotus temple.jpg',
        description: 'Guugram city: This is a longer card with supporting text below',
        duration: '1 Hour',
        price: 'From ₹ 12342 per person',
        path: '/pages/page3'
    },
    {
        id: 17,
        title: 'Day tour',
        image: './images/waterpark.png',
        description: 'Delhi: Located near the Metro Walk Mall in Rohini Adventure Island is a popular water park ',
        duration: '12 Hour',
        price: 'From ₹ 1234 per person',
        path: '/pages/page10'
    },
]
// export const saveCartToLocalStorage = (cartData) => {
//     localStorage.setItem('cartData', JSON.stringify(cartData));
// };
// // Function to retrieve cart data from localStorage
// export const getCartFromLocalStorage = () => {
//     const storedCartData = JSON.parse(localStorage.getItem('cartData')) || [];
//     return storedCartData;
// };

// export const saveWishListToLocalStorage = (wishListData) => {
//     localStorage.setItem('wishListData', JSON.stringify(wishListData));
// };
// // Function to retrieve cart data from localStorage
// export const getWishListFromLocalStorage = () => {
//     const storedWishListData = JSON.parse(localStorage.getItem('wishListData')) || [];
//     return storedWishListData;
// };

// const combinedData = [...CultureData, ...SportsData, ...NatureData, ...FoodData];
// let wishListData = getWishListFromLocalStorage();
// export const addToWishList = (selectedProductId) => {
//     if (combinedData.length > 0) {
//         const selectedProduct = combinedData.find(item => item.id === selectedProductId);
//         if (selectedProduct) {
//             const isProductAlreadyInWishList = wishListData.some(item => item.id == selectedProductId);
//             if (!isProductAlreadyInWishList) {
//                 wishListData.push(selectedProduct);
//                 saveWishListToLocalStorage(wishListData); // Save updated wishListData to localStorage
//             }
//         }
//     }
// };


export const Partners = [
    {
        id: 1,
        image: "./images/amzaing_ind_logo.png",

    },
    {
        id: 1,
        image: "./images/Taj-destination-logo.png",

    },
    {
        id: 1,
        image: "./images/gets_holi_logo.png",

    },
    {
        id: 1,
        image: "./images/Realx_partner_logo.png",

    },
    {
        id: 1,
        image: "./images/oasis_travel_logo.jpeg",

    },
    {
        id: 1,
        image: "./images/amzaing_ind_logo.png",

    },
]

export const reviewsData = [
    {
        image: 'https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(1).webp',
        name: 'Maria Smantha',
        role: 'Form Bareilly',
        location: '',
        quote: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.',
        rating: 4.5,
    },
    {
        image: 'https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(2).webp',
        name: 'Lisa Cudrow',
        role: 'From Gurgaon',
        location: '',
        quote: 'Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid commodi.',
        rating: 5,
    },
    {
        image: 'https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(9).webp',
        name: 'John Smith',
        role: 'From Delhi',
        location: '',
        quote: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti.',
        rating: 4,
    },
];
